const PASSCODE_KEY = 'app_passcode'

export function getStoredPasscode() {
  const stored = localStorage.getItem(PASSCODE_KEY)
  return stored ? decodeBase64(stored) : undefined
}

export function savePasscode(passcode: string) {
  localStorage.setItem(PASSCODE_KEY, encodeBase64(passcode))
}

export function removePasscode() {
  localStorage.removeItem(PASSCODE_KEY)
}

export function encodeBase64(value: string): string {
  const encoder = new TextEncoder()
  const uint8Array = encoder.encode(value)
  const binaryString = String.fromCharCode(...uint8Array)
  return btoa(binaryString)
}

export function decodeBase64(encoded: string): string {
  const decodedBinary = atob(encoded)
  const decoder = new TextDecoder()
  return decoder.decode(
    new Uint8Array(decodedBinary.split('').map((char) => char.charCodeAt(0)))
  )
}
